import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '../../components/boutons/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ResponsiveService } from '../../services/reponsive.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { ClientActions } from '../../store/client/client.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-payment-error',
  imports: [RouterLink, ButtonComponent, TranslateModule, NgClass, AsyncPipe],
  templateUrl: './payment-error.component.html',
  styleUrl: './payment-error.component.scss'
})
export class PaymentErrorComponent {
  constructor(
    public responsiveService: ResponsiveService,
    private store: Store
  ) {
    this.store.dispatch(ClientActions.loadClient())
  }
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;
}
